<template>
    <div v-if="planoConta" class="card card-body shadow-sm mt-0">
      <div class="form-header d-flex justify-content-between align-items-center">
        <h4 class="form-title">Detalhes do Plano de Conta</h4>
        <router-link to="/financeiro/planos-contas">
          <button class="btn btn-secondary btn-sm">Voltar</button>
        </router-link>
      </div>
  
      <div class="form-content mt-3">
        <!-- Seção 1 -->
        <FormSection title="">
          <p><strong>Nome:</strong> {{ planoConta.nome || 'Não informado' }}</p>
          <p><strong>Tipo:</strong> {{ planoConta.tipo || 'Não informado' }}</p>
          <p><strong>Ativo:</strong> {{ verificarAtivo(planoConta?.ativo) }}</p>
        </FormSection>
  
        <!-- Seção 2 -->
        <FormSection title="">
          <p><strong>Descrição:</strong> {{ planoConta.descricao || 'Não informado' }}</p>
        </FormSection>
      </div>
    </div>
  
    <div v-else>
      <LoadingSpinner />
    </div>
  </template>
  
  <script>
  import axios from "@/services/axios";
  import FormSection from "@/components/Layout/FormSection.vue";
  
  export default {
    components: { FormSection },
    data() {
      return {
        planoConta: null,
      };
    },
    methods: {
      async carregarDetalhesPlanoConta() {
        try {
          const response = await axios.get(
            `/financeiro/planos-contas/${this.$route.params.id}`
          );
          this.planoConta = response.data;
        } catch (error) {
          console.error("Erro ao carregar os detalhes do plano de conta:", error);
        }
      },
  
      verificarAtivo(valor) {
        if (valor === undefined || valor === null) {
          return "Não informado";
        }
        return valor ? "Ativo" : "Inativo";
      },
    },
    mounted() {
      this.carregarDetalhesPlanoConta();
    },
  };
  </script>
  
  <style scoped>
  .card {
    max-width: 90%; /* Ajustado para centralizar melhor */
    margin: 0 auto;
  }
  
  .form-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0rem;
  }
  
  .form-header h4 {
    margin: 0;
    font-weight: bold;
    text-align: left;
  }
  
  .form-content {
    margin-top: 1.5rem;
  }
  
  button.btn-sm {
    padding: 6px 12px;
  }
  </style>
